/**
 * オプション設定ページ用のスクリプト
 */
if (is_route('extension_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        extension_setting_event_set();
        extension_setting_ip_restriction_event_set();
        extension_setting_authorization_event_set();
        extension_setting_drive_report_event_set();
        extension_setting_drive_report_information_form_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
 window.extension_setting_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        // 設定モーダルを表示
        // _modal.create(this, 'setting-modal', ['holding_id']);
        _modal.create(this, 'setting-modal', ['holding_id'], false, function () {
            //IPアドレス制限の初期表示
            if(($('[name="use_ip_restriction"]:checked')).length && ($('[name="use_ip_restriction"]:checked').val()) == 0){
                $('#use_ip_restriction_form').css('display', 'none');
            } else {
                $('#use_ip_restriction_form').css('display', 'inline-block');
            }
            //運行日誌の初期表示
            if(($('[name="drive_report"]:checked')).length && ($('[name="drive_report"]:checked').val()) == 0){
                $('#drive_report_form').addClass('display-none');
                $('#confirm_drive_operation_form').addClass('display-none');
            } else {
                $('#drive_report_form').removeClass('display-none');
                $('#confirm_drive_operation_form').removeClass('display-none');
                $('#titled-box-frame').css('width', '67%');
            }
            //運行日誌の日数の初期表示
            if(($('[name="page_configs[drive_report_not_measured_information_flag]"]:checked')).length && ($('[name="page_configs[drive_report_not_measured_information_flag]"]:checked').val()) == 0){
                $('#drive_report_information_form').addClass('display-none');
            } else {
                $('#drive_report_information_form').removeClass('display-none');
            }
            // 確認方法表示/非表示設定
            $(document).on('change', 'input[name="is_display_confirmed_method_type"]', function () {
                let selectBlock = $('.select-confirm-method');
                if ($("input[name='is_display_confirmed_method_type']:checked").val() === '1') {
                    selectBlock.removeClass('d-none');
                    $(this).parents('.form-group').addClass('mb-0');
                } else {
                    selectBlock.find('select').each(function(){
                        $(this).val($(this).data('old'));
                    });
                    selectBlock.addClass('d-none');
                    $(this).parents('.form-group').removeClass('mb-0');
                }
            });
            // 個人認証の設定に応じて車両予約の選択可否を制御
            $(document).on('change', 'input[name="use_individual_authorization"]', function () {
                const vehicleReservationInput = $('[name="vehicle_reservation"]');
                const vehicleReservationFormGroup = $('#vehicle_reservation-form-group');
                if ($("input[name='use_individual_authorization']:checked").val() === '1') {
                    vehicleReservationFormGroup.toggleClass('disabled-form-group', false);
                    vehicleReservationInput.prop('disabled', false);
                } else if($("input[name='vehicle_reservation']:checked") == 0) {
                    vehicleReservationFormGroup.toggleClass('disabled-form-group', true);
                    vehicleReservationInput.prop('disabled', true);
                }
            });
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 会社設定表示 ----*/

    // 会社選択時
    $(document).on('change', '#extension_setting-modal-company_id', function() {
        if($(this).val() != null && $(this).val().length > 0){
            updateCompanyDetailForms($(this));
        }
    });

    $(document).on('change', 'input[name="drive_report"]', function() {
        if ($(this).val() == '1') {
            $('#option-drive_recorder').css('display', '');
        } else if ($(this).val() == '0') {
            $('#option-drive_recorder').css('display', 'none');
        }
    });

    // 会社設定画面表示
    function updateCompanyDetailForms(elm)
    {
        let target = '#company_detail_forms';
        let action = $(target).data('action');
        _ajax.post(action, [
            {'name': 'holding_id', 'value': $('#extension_setting-modal-holding_id').val()},
            {'name': 'company_id', 'value': $(elm).val()},
        ], function (response) {
            $(target).html(response);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    /*---- ライセンスキーの発行/再発行確認 ----*/

    // 発行/再発行確認時
    $(document).on('click', '[data-license_confirm-modal]', function (e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
        } else {
            // 設定モーダルを表示
            _modal.create(this, 'license_confirm-modal', ['holding_id']);
        }
    });

    /*---- ライセンスキーの発行/再発行 ----*/

    // 発行/再発行時
    $(document).on('click', '[data-license_create-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'license_create-modal', ['holding_id'], false, function () {
            _modal.hide('#extension_setting_license_confirm-modal');
        });
    });

}

/**
 * IPアドレス制限のイベント設定
 */
window.extension_setting_ip_restriction_event_set = function() {
    // IPアドレス制限の変更時
    $(document).on('change', '[name="use_ip_restriction"]', function() {
        if(($(this).val()) == 0){
            $('#use_ip_restriction_form').css('display', 'none');
        } else {
            $('#use_ip_restriction_form').css('display', 'inline-block');
        }
    });
}

/**
 * 運行日誌のイベント設定
 */
window.extension_setting_drive_report_event_set = function() {
    // 運行日誌の変更時
    $(document).on('change', '[name="drive_report"]', function() {
        if(($(this).val()) == 0){
            $('#drive_report_form').addClass('display-none');
            $('#confirm_drive_operation_form').addClass('display-none');
        } else {
            $('#drive_report_form').removeClass('display-none');
            $('#confirm_drive_operation_form').removeClass('display-none');
        }
    });
}

/**
 * 運行日誌の日数のイベント設定
 */
window.extension_setting_drive_report_information_form_event_set = function() {
    // 運行日誌の変更時
    $(document).on('change', '[name="page_configs[drive_report_not_measured_information_flag]"]', function() {
        if(($(this).val()) == 0){
            $('#drive_report_information_form').addClass('display-none');
        } else {
            $('#drive_report_information_form').removeClass('display-none');
        }
    });
}

/**
 * 個人認証モーダルのイベント設定
 */
window.extension_setting_authorization_event_set = function() {

    $(document).on('click', '#extension_setting_consent_modal_flag .btn-id-1', function () {
        $('#consentModal').modal('show');
    });

    // スマホ個人認証切り替えにより、営業所権限を表示する
    $(document).on('change', '#extension_setting_consent_modal_flag', function() {
        if ($("input[name='use_individual_authorization']:checked").val() === '0') {
            $('#is_available_at_office_form').toggleClass('display-none', true);
        } else if($("input[name='use_individual_authorization']:checked").val() === '1'){
            $('#is_available_at_office_form').toggleClass('display-none', false);
        }
    });

    /*---- ステップボタンクリック時 ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(nextPartSubmit).removeClass('display-none');
        bs_step_trigger(nextPartTrigger);
    });

    // 同意せずに個人認証モーダルを閉じる
    $(document).on('click', '.js-modal', function () {
        $('#consentModal').modal('hide');
        // 選択肢を「利用しない」に変える
        $("#extension_setting-modal-use_individual_authorization_0").prop("checked", true);
        $("#extension_setting_consent_modal_flag .btn-id-1").removeClass('active');
        $("#extension_setting_consent_modal_flag .btn-id-0").addClass('active');
        // 営業所権限を「利用しない」に変える
        $('#is_available_at_office_form').toggleClass('display-none', true);
    });

    // 個人認証モーダルのクリック処理
    $(document).on('click', '.bs-stepper-content', function () {
        // チェックボックスの状態を取得
        var target1 = $('[name="checkbox1"]:checked').val();
        var target2 = $('[name="checkbox2"]:checked').val();
        var target3 = $('[name="checkbox3"]:checked').val();
        if (target1 == 'on'){
            // 次へ進めるように(disable削除)
            $('[data-next-step="notice2-part"]').prop('disabled', false);
            if (target2 == 'on'){
                // 次へ進めるように(disable削除)
                $('[data-next-step="notice3-part"]').prop('disabled', false);
                if (target3 == 'on'){
                    // 保存を押せるように(disable削除)
                    $('[data-final-step="complete"]').prop('disabled', false);
                }
            }
        }

        // チェックを外したときは次に進めないようにする
        if (target1 != 'on'){
            $('[data-next-step="notice2-part"]').prop('disabled', true);
        }
        if (target2 != 'on'){
            $('[data-next-step="notice3-part"]').prop('disabled', true);
        }
        if (target3 != 'on'){
            $('[data-final-step="complete"]').prop('disabled', true);
        }
    });

    // 同意して個人認証モーダルを閉じる
    $(document).on('click', '[data-final-step="complete"]', function () {
        $('#consentModal').modal('hide');
    });

    $(document).on('click', '#extension_setting_consent_modal_flag .btn-id-1', function () {
        // チェックボックスを初期化する
        $('[name="checkbox1"]').removeAttr("checked").prop("checked", false);
        $('[name="checkbox2"]').removeAttr("checked").prop("checked", false);
        $('[name="checkbox3"]').removeAttr("checked").prop("checked", false);
        $('[data-next-step="notice2-part"]').prop('disabled', true);
        $('[data-next-step="notice3-part"]').prop('disabled', true);
        $('[data-final-step="complete"]').prop('disabled', true);
        let defaultPartTrigger = create_id('notice1-part' + '-trigger');
        let defaultPartSubmit = create_id('notice1-part' + '-submit');
        let lastPartSubmit = create_id('notice3-part' + '-submit');
        $(defaultPartTrigger).removeClass('display-none');
        $(defaultPartSubmit).removeClass('display-none');
        $(lastPartSubmit).addClass('display-none');
        bs_step_trigger(defaultPartTrigger);
    });
}
